import { Locale, TokenType } from '@mfe/shared/schema-types';

export type TokenInfo = {
  accessToken: string;
  accessTokenExpirationTime: string;
  refreshToken?: string;
  type?: TokenType;
  idToken?: string;
  locale?: Locale;
};

export enum GeneralEventTypes {
  GoToUrl = 'GoToUrl',
  SetCookie = 'SetCookie',
  GetCookie = 'GetCookie',
  OpenInNewTab = 'open-in-new-tab',
  Logout = 'Logout',
  GetAuthParams = 'GetAuthParams',
  SendAuthParams = 'SendAuthParams',
  LoginFromCode = 'LoginFromCode',
  LoginEvent = 'LoginEvent',
  Profile = 'profile',
  PushNotification = 'PushNotification',
  SetOrigin = 'SetOrigin',
  GetToken = 'GetToken',
  ChangeLanguage = 'ChangeLanguage',
  ScrollTop = 'scroll-top',
  CopyText = 'copy-text',
  VisitPlanUsage = 'visit-plan-usage',
  ScheduledInstall = 'scheduled-install',
}

export enum UsageEventTypes {
  //to MFE
  GetAuthParams = 'get-auth-params',
  ConfigUpdate = 'mv-config-update',
  RefetchPlanInfo = 'refetch-plan-info',
  // from MFE
  ChangePlan = 'change-plan',
  InvalidToken = 'invalid-or-expired-token',
  NoTokenProvided = 'no-token-provided',
  VisitPlanUsage = 'visit-plan-usage',
  Loaded = 'loaded',
  OpenInNewTab = 'open-in-new-tab',
  Installation = 'Installation',
  SendToken = 'SendToken',
}

export enum BillingEventTypes {
  // from MFE
  Autopay = 'autopay',
  ChangeBillDate = 'change-bill-date',
  InvalidToken = 'invalid-or-expired-token',
  NoTokenProvided = 'no-token-provided',
  OneTimePayment = 'one-time-payment',
  ViewStatement = 'view-statement',
  PayBill = 'paybill',
  BillingContext = 'billing-context',
  // to MFE
  Init = 'init',
  ViewStatementLoaded = 'view-statement-loaded',
  ClientConfig = 'client-config',
  Loaded = 'loaded',
  OpenInNewTab = 'open-in-new-tab',
}

export interface UpdateStatusHandlerProps {
  accountReference: string;
  updateSubscription: any;
}

export interface MicroFrontendEventHandlerMethods {
  logout: () => void;
  goTo?: any;
  sendMFEmessage?: any;
  updatePushNotificationStatusProps?: UpdateStatusHandlerProps;
  copyText?: (text: string) => void;
  scrollTop?: () => void;
  setIsAuthenticated?: (isAuthenticated: boolean) => void;
  setRedirectUrl?: (redirectUrl: string) => void;
  setLoginUrl?: (loginUrl: string) => void;
  setLogoutUrl?: (logoutUrl: string) => void;
  setIsAuthMFELoaded?: (isAuthMFELoaded: boolean) => void;
  setCookieLoginFailed?: (cookieLoginFailed: boolean) => void;
  setToken?: (token: TokenInfo) => void;
  sendToken?: () => void;
  openInNewTab?: (link: string) => void;
}

export interface OverviewEventHandlerMethods extends MicroFrontendEventHandlerMethods {
  sendMVClientInfo?: () => void;
}

export interface UsageEventHandlerMethods extends MicroFrontendEventHandlerMethods {
  sendOverviewMFEmessage?: any;
  sendMVClientInfo?: () => void;
  trackChangePlanEvent: any;
}

export interface BillingEventHandlerMethods extends MicroFrontendEventHandlerMethods {
  token: TokenInfo | null | undefined;
  statementLinkEndLoading: (invoiceNumber?: string | null, popupMessage?: boolean) => void;
  setBillingContext: any;
}
